<ul class="layout-menu">
  @for (item of menuUser; track $index) {
    @if (!item.separator) {
      <li app-menuitem [item]="item" [index]="$index" [root]="true"></li>
    } @else {
      <li class="menu-separator"></li>
    }
  }
</ul>
